import React from 'react';
import { BrowserRouter, Routes, Route, Navigate, Outlet } from 'react-router-dom';
import { CartProvider } from './context/CartContext';


// Componentes Públicos
import Navbar from './components/Navbar';
import ScrollToTop from './components/ScrollToTop';
import Footer from './components/Footer';
import Inicio from './pages/Inicio';
import DetalleProducto from './pages/DetalleProducto';
import Productos from './pages/Productos';
import QuienesSomos from './pages/QuienesSomos';
import ComoProducimos from './pages/ComoProducimos';
import Checkout from './pages/Checkout';
import SeguimientoPedidos from './pages/SeguimientoPedidos';
import PagoExitoso from './pages/PagoExitoso';
import PagoFallido from './pages/PagoFallido';
import PagoPendiente from './pages/PagoPendiente';
import PoliticaDePrivacidad from './pages/PoliticaPrivacidad';
import TerminosYCondiciones from './pages/TerminosYCondiciones';

// Componentes Privados (Admin)
// Asegurate de crear estos archivos en tu carpeta pages
import { Login } from './pages/Login';
import AdminDashboard  from './pages/AdminDashboard';

// 1. EL GUARDIÁN: Verifica si el admin tiene la "pulsera VIP" (Token)
const RutaPrivada = ({ children }) => {
  const token = sessionStorage.getItem('adminToken');
  return token ? children : <Navigate to="/admin" />;
};

// 2. EL MOLDE PÚBLICO: Envuelve las vistas de clientes con el Navbar y Footer
const LayoutPublico = () => {
  return (
    <>
      <Navbar />
      <ScrollToTop />
      <div style={{ padding: '0' }}>
        <Outlet /> {/* Aquí adentro se inyectan Inicio, Productos, etc. */}
      </div>
      <Footer />
    </>
  );
};

function App() {
  return (
    <CartProvider>
      <BrowserRouter>
        <Routes>
          
          {/* =========================================
              RUTAS PÚBLICAS (Usan el LayoutPublico)
              ========================================= */}
          <Route element={<LayoutPublico />}>
            <Route path="/" element={<Inicio />} />
            <Route path="/productos" element={<Productos />} />
            <Route path="/productos/:id" element={<DetalleProducto />} />
            <Route path="/quienes-somos" element={<QuienesSomos />} />
            <Route path="/como-producimos" element={<ComoProducimos />} />
            <Route path="/checkout" element={<Checkout />} />
            <Route path="/pedidos" element={<SeguimientoPedidos />} />
            <Route path="/pago-exitoso" element={<PagoExitoso />} />
            <Route path="/pago-fallido" element={<PagoFallido />} />
            <Route path="/pago-pendiente" element={<PagoPendiente />} />
            <Route path="/admin" element={<Login />} />
            <Route path="/politica-de-privacidad" element={<PoliticaDePrivacidad />} />
            <Route path="/terminos-y-condiciones" element={<TerminosYCondiciones />} />
          </Route>

          {/* =========================================
              RUTAS PRIVADAS ADMIN (Pantalla completa, sin Navbar)
              ========================================= */}
          
          <Route 
            path="/admin/dashboard" 
            element={
              <RutaPrivada>
                <AdminDashboard />
              </RutaPrivada>
            } 
          />

        </Routes>
      </BrowserRouter>
    </CartProvider>
  );
}

export default App;